import { render, staticRenderFns } from "./PrimaryNavSpecial.vue?vue&type=template&id=1ec62aa8&scoped=true"
import script from "./PrimaryNavSpecial.vue?vue&type=script&lang=js"
export * from "./PrimaryNavSpecial.vue?vue&type=script&lang=js"
import style0 from "./PrimaryNavSpecial.vue?vue&type=style&index=0&id=1ec62aa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec62aa8",
  null
  
)

export default component.exports